import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppVersion, BuildVersion } from '@core';
import { PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { VersionInfoQueryHandler } from '../../application/handlers';

@Component({
  selector: 'lib-version-info',
  templateUrl: './version-info.component.html',
  styleUrls: ['./version-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, PageLayoutComponent],
  providers: [VersionInfoQueryHandler]
})
export class VersionInfoComponent {
  private readonly versionInfoQueryHandler: VersionInfoQueryHandler = inject(VersionInfoQueryHandler);

  readonly appVersion: string = AppVersion;
  readonly buildVersion: string = BuildVersion;

  readonly newestVersion: Signal<string | undefined> = toSignal(this.versionInfoQueryHandler.newestVersion());

  readonly availableVersions: Signal<string[] | undefined> = toSignal(this.versionInfoQueryHandler.availableVersions());
}
